import { render } from "./lang-select.vue?vue&type=template&id=68d8e7f5&ts=true"
import script from "./lang-select.vue?vue&type=script&lang=ts"
export * from "./lang-select.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__